import { useEffect, useState } from "react";
import { createAuthenticatedClient } from "../utils/apiClient";
import { getStoredToken } from "../utils/installAuthToken";

const PARTIES_API = "https://directory.poc.mrc.ai/api/parties";

// Names already fetched this session, so tables don't refetch per cell
const nameCache = new Map();

const fetchName = (partyId) => {
  if (!nameCache.has(partyId)) {
    const pending = createAuthenticatedClient(getStoredToken())
      .get(`${PARTIES_API}/${partyId}`)
      .then((res) => res.data?.name || res.data?.legalName || "Unknown party")
      .catch(() => {
        nameCache.delete(partyId); // try again next time
        return "Unknown party";
      });
    nameCache.set(partyId, pending);
  }
  return nameCache.get(partyId);
};

/**
 * Directory names for a list of party IDs: { [partyId]: name }.
 * Never shows the raw ID; a party that can't be loaded is "Unknown party".
 */
export const usePartyNames = (partyIds) => {
  const [names, setNames] = useState({});
  const key = [...new Set((partyIds || []).filter(Boolean))].sort().join(",");

  useEffect(() => {
    let cancelled = false;
    const ids = key ? key.split(",") : [];
    Promise.all(ids.map(async (id) => [id, await fetchName(id)])).then((pairs) => {
      if (!cancelled) setNames(Object.fromEntries(pairs));
    });
    return () => {
      cancelled = true;
    };
  }, [key]);

  return names;
};
